module.exports = __webpack_public_path__ + "img/fawry.47235274.png";